module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Valkyrie.21619ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Valkyrie.jpg
// module id = g6Yc
// module chunks = 0